import * as buffer from 'buffer';
import * as process from 'process';

(window as any).globalThis = window;
(window as any).global = window;
(window as any).process = process;
(window as any).Buffer = (buffer as any).Buffer;

// remove console group method
console.group = () => { };
console.debug = () => { };

//https://github.com/angular/components/issues/24979
document.addEventListener('mousemove', () => { }, {
  passive: false,
  capture: true,
});
